import addNotification from '../../../../__util__/notifications';

export const handleFormTemplateFailure = (error, notificationDomRef, setFormTemplatesError, userAction) => {
  if (error.response === undefined || error.response.status !== 400)
    return setFormTemplatesError(error, error.config.method);

  const apiErrorMessage = error.response ? error.response.data.error : error.message;

  const errorMessage = apiErrorMessage || getFormTemplateFailureMessage(userAction);

  addNotification(notificationDomRef.current, 'Error', errorMessage, 'danger');
};

export const handleFormTemplateSuccess = (notificationDomRef, setFormTemplatesError, userAction, customMessage) => {
  setFormTemplatesError({}, null);
  addNotification(
    notificationDomRef.current,
    'Success',
    getFormTemplateSuccessMessage(userAction, customMessage),
    'default',
  );
};

export const getFormTemplateFailureMessage = (userAction) => {
  switch (userAction) {
    case 'saveTrialContainer':
    case 'saveWorkflow':
    case 'saveTemplate':
      return 'Form template was not saved, please try again.';
    default:
      return '';
  }
};

export const getFormTemplateSuccessMessage = (userAction, customMessage) => {
  switch (userAction) {
    case 'saveTrialContainer':
    case 'saveWorkflow':
    case 'saveTemplate':
      return customMessage || 'Form Template was saved.';
    case 'activeToggleTemplate':
      return customMessage || '';
    case 'duplicateTemplate':
      return customMessage || 'Form Template copied.';
    default:
      return '';
  }
};
